/**
 * DeviceSortControl — escolha da ordem de listagem da aba Dispositivos.
 *
 * DEVICES-FILTER-SORT-1. A lista NÃO é mais ordenada de forma fixa pelo
 * último batimento: o operador escolhe o critério. O padrão passa a ser uma
 * chave ESTÁVEL (identificação), porque a ordem por batimento se reorganiza
 * sozinha a cada auto-refresh e as linhas fogem do cursor. A triagem
 * histórica (batimento mais recente) continua a 1 clique no atalho ao lado.
 */
import { SORT_GROUPS, SORT_OPTIONS, TRIAGE_SORT_ID } from "../../lib/deviceQuery.js";

export default function DeviceSortControl({ sortId, onChange, className = "" }) {
  const isTriage = sortId === TRIAGE_SORT_ID;
  return (
    <div
      role="group"
      aria-label="Ordem de listagem"
      className={"flex items-end gap-2 " + className}
    >
      <div className="min-w-0">
        <label className="label" htmlFor="devices-sort">
          Ordenar por
        </label>
        <select
          id="devices-sort"
          value={sortId}
          onChange={(e) => onChange(e.target.value)}
          className="w-full text-xs bg-noc-bg/60 border border-noc-border
                     rounded px-2 py-1.5 text-noc-text h-9"
        >
          {SORT_GROUPS.map((g) => {
            const items = SORT_OPTIONS.filter((s) => s.group === g.id);
            if (!items.length) return null;
            return (
              <optgroup key={g.id} label={g.label}>
                {items.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.label}
                  </option>
                ))}
              </optgroup>
            );
          })}
        </select>
      </div>
      <button
        type="button"
        onClick={() => onChange(TRIAGE_SORT_ID)}
        aria-pressed={isTriage}
        title="Ordem de plantão: quem bateu mais recentemente primeiro (era a ordem fixa antiga)"
        className={
          "h-9 shrink-0 text-[11px] px-2.5 rounded-md border transition-colors "
          + (isTriage
            ? "border-noc-accent bg-noc-accent/15 text-noc-accent font-semibold"
            : "border-noc-border text-noc-text2 hover:bg-noc-panel2")
        }
      >
        Triagem por batimento
      </button>
    </div>
  );
}
